import NewStandard from './NewStandard'

export default {
  NewStandard
}